import { render, staticRenderFns } from "./MailTemplateDetail.vue?vue&type=template&id=7b90489f"
import script from "./MailTemplateDetail.vue?vue&type=script&lang=js"
export * from "./MailTemplateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports